import { crud } from "@/mixins/urlMixin";

export default {
  license: crud("license"),
  licenseReviewLogs: crud("license/reviewLogs"),
  forward: "license/approve",
  rewind: "license/rewind",
  hold: "license/hold",
  decline: "license/reject",
  forwardPRB: "license/approval/forward-prb",
  approveAll: "license/multi-review",
  openInterviews: "license/prb/open/interview",
  sendPrbLetter: "license/prb/send-prb-letter",
  scheduledInterviews: "license/prb/scheduled/interview",
  generateReport: "license/reports/generate",
  licenseStats: "/codeunit/REVIEW_CU/ReviewStatsManager_getReviewStatistics",
  licenseMonthlyTrend:
    "/codeunit/REVIEW_CU/ReviewStatsManager_getLicenseMonthly",
  subscriptions: crud("/license/subscription"),
  paymentReceipt: "/codeunit/REVIEW_CU/MembershipManager_getReceiptReport",
  cpd: "codeunit/REVIEW_CU/MembershipManager_GetTotalCPDForTheYear",
  reviewUser: crud("license/review-user"),
};
